import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const ProtectedRoute = ({ children, requireAuth = true }) => {
  const { user, loading } = useAuth()
  const location = useLocation()

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="vite-loading-spinner" style={{ margin: '0 auto 1rem' }}></div>
          <p className="text-gray-600">Checking authentication...</p>
        </div>
      </div>
    )
  }

  // If route requires authentication and user is not logged in
  if (requireAuth && !user) {
    // Redirect to login page with return url
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // If route is for guests only (like login/register) and user is logged in
  if (!requireAuth && user) {
    // Redirect to dashboard or home page
    return <Navigate to="/" replace />
  }

  // User has required authentication state, render children
  return children
}

export default ProtectedRoute